var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBonusButton = function SvgBonusButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 145 145"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.038,
    cy: 72.038,
    r: 69.538,
    fill: "url(#bonus-button_svg__a)",
    stroke: "url(#bonus-button_svg__b)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bonus-button_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 0 72.038) scale(72.0381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C699D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bonus-button_svg__b",
    x1: 72.038,
    x2: 72.038,
    y1: 0,
    y2: 144.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2970DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#3378DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C4AA8"
  })))));
};
export default SvgBonusButton;